export default "__VITE_ASSET__BBi2$FhL__"